/**
 * @author liqiuqi
 * @date 2022 2022/7/27 12:55
 */
const resetPassword = {
  namespaced: true,
  state: {
    userName: "",
    userNameEncrypted: "",
    check_type: "",
    mobile: "",
    email: "",
    code: "",
    password: "",
    password_repeat: "",
  },
  getters: {
    userName: (state) => state.userName,
    userNameEncrypted: (state) => state.userNameEncrypted,
    check_type: (state) => state.check_type,
    mobile: (state) => state.mobile,
    email: (state) => state.email,
    code: (state) => state.code,
    password: (state) => state.password,
    password_repeat: (state) => state.password_repeat,
  },
  mutations: {
    updateUserName(state, userName) {
      state.userName = userName;
    },
    updateUserNameEncrypted(state, userNameEncrypted) {
      state.userNameEncrypted = userNameEncrypted;
    },
    updateCheckType(state, check_type) {
      state.check_type = check_type;
    },
    updateMobile(state, mobile) {
      state.mobile = mobile;
    },
    updateEmail(state, email) {
      state.email = email;
    },
    updateCode(state, code) {
      state.code = code;
    },
    updatePassword(state, password) {
      state.password = password;
    },
    updatePasswordRepeat(state, password_repeat) {
      state.password_repeat = password_repeat;
    },
  },
  actions: {},
};
export default resetPassword;
